// removed by extract-text-webpack-plugin
module.exports = {"page-front":"page-front","pull-left":"pull-left","pull-right":"pull-right"};


//////////////////
// WEBPACK FOOTER
// ./src/app/Index.scss
// module id = 247
// module chunks = 0